import React, { useState } from 'react';
import { BarChart3Icon, TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
type Notification = {
  id: string;
  event: string;
  date: string;
  impact: 'high_negative' | 'medium_negative' | 'low_positive' | 'medium_positive' | 'high_positive';
  acknowledgedBy: string | null;
};
const notifications: Notification[] = [{
  id: '1',
  event: 'Financial statement filed: Revenue increased 15% YoY to $285M',
  date: '3/15/2026',
  impact: 'high_positive',
  acknowledgedBy: 'Sarah Chen'
}, {
  id: '2',
  event: "News article: Golden Ticket Promotion Drives Record Valentine's Day Sales",
  date: '2/14/2026',
  impact: 'high_positive',
  acknowledgedBy: 'Sarah Chen'
}, {
  id: '3',
  event: 'DBT decreased from 8 days to 5 days (37.5% improvement)',
  date: '2/01/2026',
  impact: 'high_positive',
  acknowledgedBy: 'Sarah Chen'
}, {
  id: '4',
  event: 'News article: Wonka Industries Expands Distribution to 12 New Countries',
  date: '1/05/2026',
  impact: 'high_positive',
  acknowledgedBy: 'Sarah Chen'
}];
function ImpactIndicator({
  impact
}: {
  impact: Notification['impact'];
}) {
  if (impact === 'high_negative') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-4037">
        <div className="w-1.5 h-2 bg-red-500 rounded-sm" data-id="element-4038" />
        <div className="w-1.5 h-3.5 bg-red-500 rounded-sm" data-id="element-4039" />
        <div className="w-1.5 h-5 bg-red-500 rounded-sm" data-id="element-4040" />
      </div>;
  }
  if (impact === 'medium_negative') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-4041">
        <div className="w-1.5 h-2 bg-red-500 rounded-sm" data-id="element-4042" />
        <div className="w-1.5 h-3.5 bg-red-500 rounded-sm" data-id="element-4043" />
        <div className="w-1.5 h-5 bg-gray-200 rounded-sm" data-id="element-4044" />
      </div>;
  }
  if (impact === 'low_positive') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-4045">
        <div className="w-1.5 h-2 bg-green-500 rounded-sm" data-id="element-4046" />
        <div className="w-1.5 h-3.5 bg-gray-200 rounded-sm" data-id="element-4047" />
        <div className="w-1.5 h-5 bg-gray-200 rounded-sm" data-id="element-4048" />
      </div>;
  }
  if (impact === 'medium_positive') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-4049">
        <div className="w-1.5 h-2 bg-green-500 rounded-sm" data-id="element-4050" />
        <div className="w-1.5 h-3.5 bg-green-500 rounded-sm" data-id="element-4051" />
        <div className="w-1.5 h-5 bg-gray-200 rounded-sm" data-id="element-4052" />
      </div>;
  }
  // high_positive
  return <div className="flex items-end gap-0.5 justify-center" data-id="element-4053">
      <div className="w-1.5 h-2 bg-green-500 rounded-sm" data-id="element-4054" />
      <div className="w-1.5 h-3.5 bg-green-500 rounded-sm" data-id="element-4055" />
      <div className="w-1.5 h-5 bg-green-500 rounded-sm" data-id="element-4056" />
    </div>;
}
export function WonkaNotificationsTab() {
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const toggleAll = () => {
    if (selected.size === notifications.length) {
      setSelected(new Set());
    } else {
      setSelected(new Set(notifications.map(n => n.id)));
    }
  };
  const toggleOne = (id: string) => {
    const next = new Set(selected);
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    setSelected(next);
  };
  return <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-4057">
      <div className="p-5 border-b border-gray-200" data-id="element-4058">
        <h3 className="text-lg font-bold text-gray-900" data-id="element-4059">Notifications</h3>
      </div>
      <div className="overflow-x-auto" data-id="element-4060">
        <table className="w-full text-sm text-left" data-id="element-4061">
          <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-4062">
            <tr data-id="element-4063">
              <th className="px-5 py-3 w-10" data-id="element-4064">
                <input type="checkbox" checked={selected.size === notifications.length} onChange={toggleAll} className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" data-id="element-4065" />
              </th>
              <th className="px-5 py-3 font-medium" data-id="element-4066">Event</th>
              <th className="px-5 py-3 font-medium text-center w-32" data-id="element-4067">Date</th>
              <th className="px-5 py-3 font-medium text-center w-24" data-id="element-4068">Impact</th>
              <th className="px-5 py-3 font-medium text-center w-40" data-id="element-4069">
                Acknowledged By
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-4070">
            {notifications.map(n => <tr key={n.id} className="hover:bg-gray-50 transition-colors" data-id="element-4071">
                <td className="px-5 py-4" data-id="element-4072">
                  <input type="checkbox" checked={selected.has(n.id)} onChange={() => toggleOne(n.id)} className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" data-id="element-4073" />
                </td>
                <td className="px-5 py-4 text-gray-900" data-id="element-4074">{n.event}</td>
                <td className="px-5 py-4 text-gray-500 text-center whitespace-nowrap" data-id="element-4075">
                  {n.date}
                </td>
                <td className="px-5 py-4 text-center" data-id="element-4076">
                  <ImpactIndicator impact={n.impact} data-id="element-4077" />
                </td>
                <td className="px-5 py-4 text-gray-500 text-center" data-id="element-4078">
                  {n.acknowledgedBy ?? '--'}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="flex items-center justify-end gap-4 px-5 py-3 border-t border-gray-200 text-sm text-gray-500" data-id="element-4079">
        <span data-id="element-4080">Rows per page: 5</span>
        <span data-id="element-4081">1–4 of 4</span>
        <div className="flex gap-1" data-id="element-4082">
          <button className="p-1 rounded hover:bg-gray-100 text-gray-400 cursor-not-allowed" data-id="element-4083">
            ‹
          </button>
          <button className="p-1 rounded hover:bg-gray-100 text-gray-400 cursor-not-allowed" data-id="element-4084">
            ›
          </button>
        </div>
      </div>
    </div>;
}